import "antd/dist/reset.css";
import "./assets/styling/overwrite.css";
import "./assets/styling/tailwind.css";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n.jsx";
import "./web.config";
import Home from "./pages/home.jsx";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import Config from "./variables.json";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactQueryDevtools } from "react-query/devtools";
import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Provider as JotaiProvider } from "jotai";
import { WebRoutes } from "./handlers/enums";
import Book from "./pages/book.jsx";
import { App as AntApp, ConfigProvider } from "antd";
import { JwtKey } from "./handlers/extensions.jsx";
import { SetupAxiosDefaults } from "./handlers/axios";

const queryClient = new QueryClient();

dayjs.extend(customParseFormat);

moment.updateLocale("en", {
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
});

moment.updateLocale("nl", {
  months: [
    "Januari",
    "Februari",
    "Maart",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "December"
  ]
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <ToastContainer autoClose={5000} limit={4} theme="colored" position="top-center" pauseOnHover newestOnTop pauseOnFocusLoss closeOnClick />
      <QueryClientProvider client={queryClient}>
        <JotaiProvider>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#83BCFF",
                colorSuccess: "#69C78D",
                colorWarning: "#F0D31D",
                colorError: "#F87171",
                colorInfo: "#83BCFF",
                colorText: "#F9F9F9",
                colorTextBase: "#F9F9F9",
                colorBgBase: "#252526",
                colorBgContainer: "#39393A",
                borderRadius: 12,
                fontFamily: "Poppins, Segoe UI, sans-serif"
              },
              components: {
                Layout: {
                  bodyBg: "#252526",
                  headerBg: "transparent",
                  footerBg: "transparent"
                },
                Card: {
                  colorBgContainer: "#39393A",
                  colorBorderSecondary: "#545454"
                },
                Button: {
                  defaultBorderColor: "#83BCFF",
                  defaultColor: "#F9F9F9",
                  defaultHoverColor: "#12130F",
                  defaultHoverBorderColor: "#FF7D08",
                  defaultHoverBg: "#FF7D08"
                },
                Segmented: {
                  trackBg: "#252526"
                }
              }
            }}
          >
            <AntApp>
              <div className="min-h-screen bg-app-pattern text-custom-white">
                <div className="mx-auto flex min-h-screen w-full max-w-screen-2xl flex-col px-3 py-4 sm:px-6 lg:px-8">
                  <BrowserRouter>
                    <Routes>
                      <Route path={WebRoutes.Home} element={<Home />} />
                      <Route path={WebRoutes.Book} element={<Book />} />
                      <Route path="*" element={<Navigate replace to={WebRoutes.Home} />} />
                    </Routes>
                  </BrowserRouter>
                </div>
              </div>
            </AntApp>
          </ConfigProvider>
        </JotaiProvider>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </React.StrictMode>
  );
};

async function bootstrap() {
  const token = await JwtKey();
  SetupAxiosDefaults({
    baseURL: Config.Variables.ApiUrl,
    apiKey: process.env.REACT_APP_API_KEY,
    token
  });
  renderApp();
}

bootstrap();
